import React from "react";
import PageHeader from "../../../../../components/reusable/management/PageHeader";

// const buttonStyle = {
//     padding: "10px 18px",
//     border: "1px solid #d1d5db",
//     borderRadius: "10px",
//     background: "#fff",
//     cursor: "pointer",
//     fontWeight: 600,
//     transition: "0.2s",
// };

const DepartmentHeader = ({ onCreate, onRefresh, refreshing }) => {
    return (
        // <div
        //     style={{
        //         display: "flex",
        //         justifyContent: "space-between",
        //         alignItems: "center",
        //         flexWrap: "wrap",
        //         gap: "20px",
        //         marginBottom: "24px",
        //     }}
        // >
        //     <div>
        //         <h1
        //             style={{
        //                 margin: 0,
        //                 fontSize: "30px",
        //                 color: "#0f172a",
        //             }}
        //         >
        //             🏢 Department Management
        //         </h1>

        //         <p
        //             style={{
        //                 marginTop: "8px",
        //                 color: "#64748b",
        //                 fontSize: "15px",
        //             }}
        //         >
        //             Manage departments, department heads, workload and overall performance across your firm.
        //         </p>
        //     </div>

        //     <button
        //         style={buttonStyle}
        //         onMouseEnter={(e) => {
        //             e.currentTarget.style.background = "#eff6ff";
        //             e.currentTarget.style.borderColor = "#2563eb";
        //         }}
        //         onMouseLeave={(e) => {
        //             e.currentTarget.style.background = "#fff";
        //             e.currentTarget.style.borderColor = "#d1d5db";
        //         }}
        //     >
        //         + Create Department
        //     </button>
        // </div>
        <PageHeader
            title="🏢 Department Management"
            subtitle="Manage departments, workload and task performance across your firm."
            actions={[
                {
                    label: "Create Department",
                    icon: "+",
                    onClick: onCreate,
                },
                {
                    label: refreshing ? "Refreshing..." : "Refresh",
                    icon: "↻",
                    onClick: onRefresh,
                    disabled: refreshing,
                },
            ]}
        />
    );
};

export default DepartmentHeader;
